import { Box } from '@material-ui/core';
import { SelectFilter } from '@agilelab/plugin-wb-platform';
import {
  FeatureRequestStatus,
  FeatureRequestPriority,
  FeatureRequestView,
} from '@agilelab/plugin-wb-builder-common';

export interface MyFeatureRequestsFilterValues {
  view?: FeatureRequestView;
  status?: FeatureRequestStatus;
  priority?: FeatureRequestPriority;
  projectUrn?: string;
}

interface MyFeatureRequestsFiltersProps {
  values: MyFeatureRequestsFilterValues;
  onChange: (filters: MyFeatureRequestsFilterValues) => void;
  availableProducts: string[];
  urnDisplayNames?: Record<string, string>;
}

const STATUS_OPTIONS = Object.values(FeatureRequestStatus);
const PRIORITY_OPTIONS = Object.values(FeatureRequestPriority);
const VIEW_OPTIONS = Object.values(FeatureRequestView);

const VIEW_LABELS: Record<FeatureRequestView, string> = {
  [FeatureRequestView.MY]: 'My Requests',
  [FeatureRequestView.RECEIVED]: 'Received Requests',
};

export const MyFeatureRequestsFilters = ({
  values,
  onChange,
  availableProducts,
  urnDisplayNames = {},
}: MyFeatureRequestsFiltersProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      style={{ gap: 16 }}
      flexWrap="wrap"
      mb={2}
      role="group"
      aria-label="Feature request filters"
    >
      <SelectFilter<FeatureRequestView>
        field="View"
        value={values.view ?? FeatureRequestView.MY}
        options={VIEW_OPTIONS}
        renderOption={o => VIEW_LABELS[o]}
        renderValue={v => VIEW_LABELS[v]}
        hideClear
        onChange={val =>
          onChange({
            ...values,
            view: val ?? FeatureRequestView.MY,
            status: undefined,
            priority: undefined,
            projectUrn: undefined,
          })
        }
      />

      <SelectFilter<FeatureRequestStatus>
        field="Status"
        value={values.status}
        options={STATUS_OPTIONS}
        // Replace underscores with spaces for better readability like in IN_PROGRESS
        renderOption={o => o.replace('_', ' ')}
        renderValue={v => v.replace('_', ' ')}
        onChange={val => onChange({ ...values, status: val })}
      />

      <SelectFilter<FeatureRequestPriority>
        field="Priority"
        value={values.priority}
        options={PRIORITY_OPTIONS}
        renderOption={o => o}
        renderValue={v => v}
        onChange={val => onChange({ ...values, priority: val })}
      />

      {availableProducts.length > 0 && (
        <SelectFilter<string>
          field="Product"
          value={values.projectUrn}
          options={availableProducts}
          renderOption={o => urnDisplayNames[o] ?? o}
          renderValue={v => urnDisplayNames[v] ?? v}
          onChange={val => onChange({ ...values, projectUrn: val })}
        />
      )}
    </Box>
  );
};
